// extracted by mini-css-extract-plugin
module.exports = {"noDataMessage":"ActivityRouteGuard_noDataMessage__DGqHC"};